import { createContext } from 'react';

const subscriptionsContext = createContext();

export default subscriptionsContext;
